/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 16:35:20                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-05 16:43:06                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * SuperAdminGuard: Is a components use to check if the user is a super admin.
*/

/* Imports */
import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";
/***/

/**
* SuperAdminGuard: Is a components use to check if the user is a super admin.
* @param children - The children that will be display if the user is a super admin. 
*/
export default function SuperAdminGuard({
  children
}: {
  children: React.ReactNode;
}) {
  const { keycloak } = useKeycloak();

  if (keycloak.realmAccess?.roles.includes("ROLE_SUPER_ADMIN")) return children;
  else return <Navigate to="/dashboard" replace />;
}
/***/
